<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <large-base-card>
    <div class="d-flex align-center">
      <div class="text-h4">
        {{ $t('todayAccountData') }}
      </div>
      <v-spacer/>
      <div
        class="d-flex align-center"
        style="height: 48px;"
      >
        <v-icon>mdi-bank</v-icon>
      </div>
    </div>
    <div
      v-if="billContent"
      class="text-body-1"
      style="max-height: 400px;overflow-y: scroll"
    >
      <div class="mt-4">
        <div class="d-flex justify-space-between align-center">
          <div>
            {{ $t('sales') }} {{ $t('all') }}
          </div>
          <div>
            {{ billContent.total | priceDisplay }}
          </div>
        </div>
        <div class="d-flex justify-space-between mt-1">
          <div>{{ $t('netto') }}/ {{ $t('tax') }}</div>
          <div>{{ billContent.fTotalTe }} €/{{ billContent.fTotalTax }} €</div>
        </div>
        <v-divider class="my-4"/>
      </div>
      <template v-for="(total,index) in taxGroupInfo">
        <div :key="total.taxRatePercentage+'-'+index">
          <div class="d-flex justify-space-between">
            <div> {{ $t('sales') }} {{ total.taxRatePercentage }}%</div>
            <div class="font-weight-bold">
              {{ total.groupTotal | priceDisplay }}
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div>{{ $t('netto') }}/ {{ $t('tax') }}</div>
            <div>{{ total.nettoumsatz }} €/{{ total.umsatzsteuer }} €</div>
          </div>
          <v-divider class="my-4"/>
        </div>
      </template>
    </div>
  </large-base-card>
</template>

<script>

  import LargeBaseCard from '@/composable/LargeBaseCard'

  export default {
    components: { LargeBaseCard },
    props: {
      info: {},
      date: {},
    },
    data () {
      return {
        series: [],
      }
    },
    computed: {
      billContent () {
        return this.info?.taxInfos?.content
      },
      taxGroupInfo () {
        return this.billContent?.taxInfos?.filter(t => t.consumeTypeName === 'Total')
      },
    },
    async mounted () {

    },

  }
</script>
